import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from 'apps/new-web/views/component';
import createLayout from 'apps/new-web/views/pages/create-layout';
import { connect } from 'react-redux';
import I18n from 'apps/new-web/views/components/i18n';
import HeaderNav from 'apps/new-web/views/components/header';
import Image from 'apps/new-web/views/components/image';
import PrimaryButton from 'apps/new-web/views/components/primary-button';

export class PureUpdateExplainer extends BaseComponent {
  static getAdditionalHeadTags() {
    return `<meta name="description" content="${I18n.translate(
      'We are making our website better for you!'
    )}" />`;
  }

  static get propTypes() {
    return {
      layout: PropTypes.object.isRequired,
      user: PropTypes.object
    };
  }

  render() {
    const { mediaType } = this.props.layout;
    return (
      <div className="update-explainer-page">
        <HeaderNav mediaType={ mediaType } />
        <main>
          <Image
            className="hide-on-desktop top-image"
            src="/components/update-explainer/img/running.jpg"
            alt={ I18n.translate('Female exercising in her living room with a bar behind her head watching the [ifit] app.', { ifit: 'iFIT' }) }
          />
          <div className="copy-body">
            <h1><I18n>We're making our website better for you!</I18n></h1>
            <p><I18n args={{ ifit: 'iFIT', }}>At [ifit], we understand that change is a necessary part of life. That's why we're improving our site with your feedback in mind to help you find exactly what you need, right when you need it.</I18n></p>
            <p><I18n args={{ ifit: 'iFIT.com', }}>
            You may notice some feature changes to [ifit] that include:</I18n></p>

            <h2><I18n args={{ ifit: 'iFIT' }} desc="Describes the user iFIT account.">My [ifit]</I18n></h2>
            <h3><I18n desc="A feature that allows users to keep track of their fitness status.">Fit Score</I18n></h3>
            <p><I18n args={{ ifitApp: '<a href="/apps">iFIT app</a>' }}>Find your workout stats and milestones in the [ifitApp].</I18n></p>
            <h3><I18n desc="A feature that allows users view their personal information.">Profile</I18n></h3>
            <p><I18n args={{ ifit: 'iFIT', ifitApp: '<a href="/apps">iFIT app</a>' }}>Locate information about your [ifit] equipment in the Settings section of the [ifit] app and find your workout history in the Calendar section of the [ifitApp]!</I18n></p>

            <h2><I18n args={{ ifit: 'iFIT', }} desc="Describes the user social media features.">Social</I18n></h2>
            <h3><I18n desc="A feature that allows users to interact with others.">Community</I18n></h3>
            <p><I18n args={{ facebook: '<a href="https://www.facebook.com/ifit/">Facebook</a>', instagram: '<a href="https://www.instagram.com/ifit/">Instagram</a>' }}>Find your next accountability partner on our established [facebook] group and [instagram] accounts.</I18n></p>
            <h3><I18n desc="A feature that allows users to interact with others.">Messages</I18n></h3>
            <p><I18n args={{ facebook: '<a href="https://www.facebook.com/ifit/">Facebook</a>', ifit: 'iFIT' }}>Engage with other [ifit] members in our official [facebook] group.</I18n></p>
            <h3><I18n desc="A feature that allows users to interact with others.">Competitions</I18n></h3>
            <p><I18n args={{ ifitApp: '<a href="/apps">iFIT app</a>' }}>Explore the library of Challenges in the [ifitApp]</I18n></p>

            <h2><I18n args={{ ifit: 'iFIT', }} desc="Describes the iFIT news and information sections.">Programs &amp; Blogs</I18n></h2>
            <h3><I18n desc="A feature that displays workouts for the day.">Daily</I18n></h3>
            <p><I18n args={{ ifitApp: '<a href="/apps">iFIT app</a>' }}>Discover daily workouts in our extensive Library and get recommendations in the [ifitApp].</I18n></p>

            <h2><I18n args={{ ifit: 'iFIT', }} desc="Describes the user's workout history.">Log</I18n></h2>
            <h3><I18n desc="A feature that shows available exercise programs.">Workouts and more</I18n></h3>
            <p><I18n args={{ ifitApp: '<a href="/apps">iFIT app</a>' }}>View automatically logged workouts in your History, and track workouts with third-party devices connected to the [ifitApp].</I18n></p>
            <PrimaryButton
              label={ I18n.translate('Return to Dashboard') }
              href="/dashboard"
            />
          </div>

          <div className="image-column">
            <Image
              src="/components/update-explainer/img/bar.jpg"
              alt={ I18n.translate('Black woman exercising in her living room with a bar behind her head watching the [ifit] app on a smart phone.', { ifit: 'iFIT' }) }
            />
            <Image
              src="/components/update-explainer/img/running.jpg"
              alt={ I18n.translate('White man running in place in front of the [ifit] TV app.', { ifit: 'iFIT' }) }
            />
            <Image
              src="/components/update-explainer/img/yoga.jpg"
              alt={ I18n.translate('Brown man performing the cobra yoga pose watching the [ifit] app on a tablet.', { ifit: 'iFIT' }) }
            />
          </div>
        </main>
      </div>
    );
  }
}

const UpdateExplainer = connect(
  (state) => {
    return {
      user: state.user,
      layout: state.layout,
    };
  }
)(PureUpdateExplainer);

export default createLayout(UpdateExplainer);
